// @core
import { useState } from 'react';
import PropTypes from 'prop-types';
import { i18n } from 'core/i18n'

// @components
import { OKCheckbox } from 'commonsComponents/OKCheckbox'
import { OKMessage, MESSAGE_TYPE_ASSISTANT } from 'commonsComponents/OKMessage'
import { ModalTransferTooltip } from '../modalTooltip/modalTooltip';

import ContactCenterRender from "components/conditionalRender/contactCenterRender"

// @helpers
import { getAssitantTitle } from '../../helpers/bringAccountHelper';
import { taggingAuthoriseCheckbox, taggingCloseTooltip, taggingOpenTooltip, taggingUnderstoodTooltip } from '../../helpers/bringAccountTagging';

// @constants
import { AUTHORISE_REQUEST, AUTHORISE_STEPS, CHECKBOX_AUTHORIZATION, STATUSES } from '../../constants/bringAccountConstants';

const { FormattedText, FormattedTextWithNamedVariables, formatText } = i18n;


import './transferAuthorizationStep.scss';


export const TransferAuthorizationStep = ({ immBringAccount, isOffice, actions }) => {
    const [tooltipType, setTooltipType] = useState(null)

    const disclaimerTitle = getAssitantTitle(isOffice);

    const disclaimerDescriptionOne = isOffice
        ? 'transfer_account_oficina-transfer_account_from_another_bank_step3_disclaimer_of'
        : 'transfer_account_cc-transfer_account_from_another_bank_step3_disclaimer_cc'

    const disclaimerDescriptionTwo = isOffice
        ? 'transfer_account_oficina-transfer_account_from_another_bank_step3_disclaimer_2_of'
        : 'transfer_account_cc-transfer_account_from_another_bank_step3_disclaimer_2_cc'

    const handleOpenTooltip = (type) => {
        setTooltipType(type);
        const component = type === AUTHORISE_REQUEST ? 'requestProducts' : 'stepsAuthorization';
        taggingOpenTooltip(component)
    }

    const resetTooltipType = () => {
        setTooltipType(null);
    }

    const handleCloseTooltip = (isClose) => {
        resetTooltipType()
        taggingCloseTooltip(isClose)
    }

    const handleAcceptTooltip = () => {
        resetTooltipType()
        taggingUnderstoodTooltip()
    }

    const handleCheckboxChange = (type, checkboxItem) => {
        actions.updateAuthoriseCheckbox(type, checkboxItem)
        taggingAuthoriseCheckbox(type, checkboxItem);
    }

    const buildCheckboxes = (type) => (
        CHECKBOX_AUTHORIZATION[type].map((checkboxItem, index) => {
            const checkboxValue = immBringAccount.getIn([type, checkboxItem.name]);
            return (
                <OKCheckbox
                    key={checkboxItem.name}
                    idName={checkboxItem.name}
                    value={checkboxValue}
                    onChange={({ target }) => handleCheckboxChange(type, { name: checkboxItem.name, isChecked: target.checked, index })}
                    label={formatText(checkboxItem.label)}
                />
            )
        })
    )

    const buildSubtitle = () => {
        const entityStatus = immBringAccount.getIn(['entity', 'status']);
        const bankName = immBringAccount.getIn(['entity', 'bank_name']);

        if (entityStatus === STATUSES.ERROR || !bankName) {
            return <FormattedText value="transfer_account-transfer_account_from_another_bank_step_3_authorization_text_bank_failure" />
        }
        return (
            <FormattedTextWithNamedVariables
                value="transfer_account-transfer_account_authorization_text"
                namedVariables={{ bank_name: bankName }}
            />
        )
    }

    return (
        <div className="transfer-account__transfer-authorization">
            <div>
                <h2 className='transfer-account__transfer-authorization__title'>
                    <FormattedText value="transfer_account-transfer_account_from_another_bank_step3_subtitle" />
                </h2>
            </div>

            <div>
                <h5 className='transfer-account__transfer-authorization__informative-section'>
                    {buildSubtitle()}
                </h5>
                <button className='btn btn-link btn-transparent transfer-account__transfer-authorization__button-tooltip' onClick={() => handleOpenTooltip(AUTHORISE_REQUEST)}>
                    <FormattedText value="transfer_account-transfer_account_from_another_bank_step3_tooltip_text" />
                </button>


                <ContactCenterRender>
                    <div className='transfer-account__transfer-authorization__disclaimer'>
                        <OKMessage title={disclaimerTitle} type={MESSAGE_TYPE_ASSISTANT}>
                            <FormattedText value={disclaimerDescriptionOne} />
                        </OKMessage>
                    </div>
                </ContactCenterRender>

                <p className='transfer-account__transfer-authorization__checkbox-title'>
                    <FormattedText value="transfer_account-transfer_account_from_another_bank_step3_checkbox1_title" />
                </p>

                <div>
                    {buildCheckboxes(AUTHORISE_REQUEST)}
                </div>

                <div className='transfer-account__transfer-authorization__consents'>
                    <p>
                        <FormattedText value="transfer_account-transfer_account_from_another_bank_step3_checkbox1_consents" />
                    </p>
                    <p>
                        <FormattedText value="transfer_account-transfer_account_from_another_bank_step3_checkbox1_consents_1" />
                    </p>
                    <p>
                        <FormattedText value="transfer_account-transfer_account_from_another_bank_step3_checkbox1_consents_2" />
                    </p>
                </div>
            </div>

            <div>
                <div>
                    <h2 className='transfer-account__transfer-authorization__title'>
                        <FormattedText value="transfer_account-transfer_account_from_another_bank_step3_subtitle_2" />
                    </h2>
                </div>
                <h5 className='transfer-account__transfer-authorization__informative-section'>
                    <FormattedText value="transfer_account-transfer_account_from_another_bank_step3_checkbox2_header" />
                </h5>
                <button className='btn btn-link transfer-account__transfer-authorization__button-tooltip' onClick={() => handleOpenTooltip(AUTHORISE_STEPS)}>
                    <FormattedText value="transfer_account-transfer_account_from_another_bank_step3_tooltip_text" />
                </button>

                <ContactCenterRender>
                    <div className='transfer-account__transfer-authorization__disclaimer'>
                        <OKMessage title={disclaimerTitle} type={MESSAGE_TYPE_ASSISTANT}>
                            <FormattedText value={disclaimerDescriptionTwo} />
                        </OKMessage>
                    </div>
                </ContactCenterRender>


                <p className='transfer-account__transfer-authorization__checkbox-title'>
                    <FormattedText value="transfer_account-transfer_account_from_another_bank_step3_checkbox1_title" />
                </p>

                <div>
                    {buildCheckboxes(AUTHORISE_STEPS)}
                </div>
                <p className='transfer-account__transfer-authorization__consents'>
                    <FormattedText value="transfer_account-transfer_account_from_another_bank_step3_checkbox2_consents" />
                </p>
            </div>
            {
                tooltipType && (
                    <ModalTransferTooltip type={tooltipType} onClose={handleCloseTooltip} onAccept={handleAcceptTooltip} />
                )
            }
        </div>
    );
}

TransferAuthorizationStep.propTypes = {
    immBringAccount: PropTypes.object.isRequired,
    isOffice: PropTypes.bool.isRequired,
    actions: PropTypes.shape({
        updateAuthoriseCheckbox: PropTypes.func.isRequired,
    }).isRequired,
};
